<template>
  <!-- LISTE DES DERNIERS VENTES -->
  <div class="card mb-25 border-0 rounded-0 bg-white">
    <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
      <div
        class="mb-15 mb-md-30 d-sm-flex align-items-center justify-content-between"
      >
        <h6 class="card-title fw-bold mb-0">LISTE DES DERNIERES REGLEMENTS</h6>
        <!-- <div
          class="card-select mt-10 mt-sm-0 mb-10 mb-sm-0 d-flex align-items-center ps-10 pe-10 pt-5 pb-5"
        >
          <span class="fw-medium text-muted me-8">Status</span>
          <select
            class="form-select shadow-none text-black border-0 ps-0 pt-0 pb-0 pe-20 fs-14 fw-medium"
          >
            <option selected class="fw-medium">Show All</option>
            <option value="1" class="fw-medium">In Stock</option>
          </select>
        </div> -->
        <router-link
          to="/Reglements"
          class="card-btn fw-medium d-inline-block text-decoration-none transition ps-10 pe-10 pt-5 pb-5"
        >
          Voir la liste
        </router-link>
      </div>
      <div class="table-responsive">
        <table class="table text-nowrap align-middle mb-0">
          <thead>
            <tr>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
              >
                #
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Date
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Client
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Montant regler
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Reste à payer
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Vente
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="reg in elements" :key="reg.id">
              <th class="shadow-none lh-1 fw-bold ps-0">
                <router-link
                  to="/product-details"
                  class="text-decoration-none text-black-emphasis"
                >
                {{ (reg) ? reg.id : "" }}
                </router-link>
              </th>
              <td class="shadow-none lh-1 fw-semibold text-black-emphasis">
                {{ (reg) ? format_Date(reg.dateReglement) : "" }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-body-tertiary">
                {{ (reg.vente) ?
                  " [ "+reg.vente.client.code+" ] "+reg.vente.client.nom+" "+reg.vente.client.prenoms
                   : "" }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-body-tertiary">
                <span class="badge text-outline-success">
                <b>{{ (reg.montant) ? reg.montant : "" }}</b>  Fcfa
              </span>
              </td>
              <td class="shadow-none lh-1 fw-medium text-body-tertiary">
                {{ (reg.restAPayer) ? reg.restAPayer : "" }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-body-tertiary">
                #{{ (reg.vente.id) ? reg.vente.id : "" }}
              </td>
              
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from "vue";
import stockReport from "./stockReport.json";
import ApiService from "@/services/ApiService";
import { error, format_Date } from "@/utils/utils";
import { Reglement } from "@/models/Reglement";

export default defineComponent({
  name: "StockReport",
  setup() {

    const elements = ref<Array<Reglement>>([])

    function getAll(page = 1, limi = 10, searchTerm = '') {
        return ApiService.get(`reglements?page=${page}&limit=${limi}&mot=${searchTerm}&`)
        .then(({ data }) => {
          elements.value = data.data.data;
        })
        .catch(({ response }) => {
          error(response.data)
        });
    }

    onMounted(() => {
      getAll();
    });

    return {
      stocks: stockReport,
      elements,
      format_Date
    };

  },
});
</script>